import ChallengeReview from './ChallengeReview';

export default ChallengeReview;
